import React from 'react';

const PhoneNumberCard = ({
  phoneNumber,
  isSelected,
  onSelect
}) => {
  return (
    <div
      onClick={() => onSelect(phoneNumber.id)}
      className={`p-4 border-2 rounded-lg cursor-pointer transition-colors ${
        isSelected
          ? 'border-[#075e54] bg-[#075e54] bg-opacity-10'
          : 'border-gray-300 hover:border-[#075e54] hover:bg-gray-50'
      }`}
    >
      <div className="flex items-center justify-between">
        <div className="text-left">
          <div className="font-semibold text-gray-900">
            {phoneNumber.phone_number}
          </div>
          <div className="text-sm text-gray-600">
            ID: {phoneNumber.id}
          </div>
          {phoneNumber.name && (
            <div className="text-sm text-gray-600">
              Name: {phoneNumber.name}
            </div>
          )}
        </div>
        {isSelected && (
          <div className="w-6 h-6 bg-[#075e54] rounded-full flex items-center justify-center">
            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhoneNumberCard;
